import Sticky from './Sticky';
import Drupal from './Drupal';
import Header from './Header';
import Toolbar from './Toolbar';
import Visible from './Visible';
import Navigation from './Navigation';
import DDTemplates from './DDTemplates';
import SmartFooter from './SmartFooter';
import LACityHeader from './LACityHeader';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import HomeHero from './HomeHero';
import HeroSlider from './HeroSlider';
import HomeSpotlights from './HomeSpotlights';
import HomeNewsEvents from './HomeNewsEvents';
import GoogleTranslateHelp from './GoogleTranslateHelp';
import EnhanceExposedFilters from './EnhanceExposedFilters';
import AccordionAnchors from './AccordionAnchors';
import $ from "jquery";

// Add the theme behaviors
Drupal.behavior((context) => {
  // Page element
  const page = document.querySelector('.page');
  const header = document.querySelector('.page-header');

  // Add target="_blank" to pdf links in field-image
  const links = document.querySelectorAll('.field-image a');
  links.forEach(link => {
    let src = link.toString().split('.').pop();
    const n = src.indexOf('?');
    src = src.substring(0, n != -1 ? n : src.length);
    if (src === 'pdf') {
      link.setAttribute('target', '_blank');
    }
  })

  // LA City Header
  if (header && !header.LACityHeader) {
    header.LACityHeader = new LACityHeader(header);
  }

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  const mainMenu = document.querySelector('#nice-menu-3');
  if (mainMenu && !mainMenu.Navigation) {
    mainMenu.Navigation = new Navigation(mainMenu);
  }

  // Controls the states of the menu and search states
  document.querySelectorAll('.toolbar').forEach((element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  const footer = document.querySelector('.page-footer');
  if (footer && !footer.SmartFooter && page && !footer.Visible) {
    footer.SmartFooter = new SmartFooter(footer, page);
    footer.Visible = new Visible(footer, -200);
  }

  // Term Navigation
  const termNavigation = document.querySelector('.term-navigation');
  if (termNavigation && !termNavigation.TermNavigation) {
    termNavigation.TermNavigation = new TermNavigation(termNavigation);
  }

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filters: {
          'All': 2,
          'Board Meeting': 296,
          'Audit Committee': 297,
          'Investments Committee': 298,
          'Benefits Administration Committee': 299,
          'Governance Committee': 300,
          'Board Event': 307,
          'Committee': 308,
          'Retiree Events/LACERS Well': 309,
          'Champion-Led Retiree Events': 310,
          'Seminars': 311,
        },
      });
    }
  });

  // Google Translate Header Help
  if (mainMenu && !mainMenu.GoogleTranslateHelp) {
    mainMenu.GoogleTranslateHelp = new GoogleTranslateHelp(mainMenu);
  }

  // ---------------------- //
  // HOMEPAGE FUNCTIONALITY //
  // ---------------------- //

  // Homepage Block Titles
  document.querySelectorAll('.front .block-title').forEach((element) => {
    if (!element.Visible) {
      element.Visible = new Visible(element);
    }
  });

  // Homepage Hero
  let block = document.querySelector('.home-hero.block');
  if (block && !block.HomeHero && !block.Visible) {
    block.HomeHero = new HomeHero(block);
    block.Visible = new Visible(block);
  }

  // Hero slider
  $('.home-hero', context).each((i, element) => {
    if (!element.heroSlider) {
      element.heroSlider = new HeroSlider(element);
    }
  });

  // Slider controls
  const $controls = $('.slickControls');
  const $track = $('.slick-track');
  const $slides = $track.children();
  const $dots = $('.slick-dots');
  const $children = $dots.children();

  function checkWidth() {
    var windowsize = $(window).width();
    if (windowsize < 768) {
      $controls.css('display', 'none');
      $($slides, context).each((i, element) => {
        console.log(element);
        $(element).css('height', $track.height());
      });
    } else if (windowsize > 767 && windowsize < 1024) {
      let totalWidth = $($dots).offset().left;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < $children.length; i++) {
        totalWidth += $($children[i]).outerWidth(true);
      }
      $controls.css('left', totalWidth + 'px');
      $controls.css('display', 'block');
    } else {
      let totalWidth = parseInt($($dots).css('padding-left'));
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < $children.length; i++) {
        totalWidth += $($children[i]).outerWidth(true);
      }
      $controls.css('left', totalWidth + 'px');
      $controls.css('display', 'block');
    }
  }
  if($dots.length < 1) {
    $controls.css('display', 'none');
  } else {
    checkWidth();
    $(window).resize(checkWidth);
  }

  // Homepage Audience
  block = document.querySelector('.home-audience.block');
  if (block && !block.Visible) {
    block.Visible = new Visible(block);
  }

  // Homepage Resources
  block = document.querySelector('.home-resources.block');
  if (block && !block.Visible) {
    block.Visible = new Visible(block);
  }

  // Homepage Spotlights
  block = document.querySelector('.home-spotlights.block');
  if (block && !block.HomeSpotlights && !block.Visible) {
    block.HomeSpotlights = new HomeSpotlights(block);
    block.Visible = new Visible(block);
  }

  // Homepage News and Events
  block = document.querySelector('.home-news-events.block');
  if (block && !block.HomeNewsEvents && !block.Visible) {
    block.HomeNewsEvents = new HomeNewsEvents(block);
    block.Visible = new Visible(block);
  }

  // Document Library
  const view = document.getElementById('views-exposed-form-document-library-page-1');
  if (view && !view.EnhanceExposedFilters) {
    view.EnhanceExposedFilters = new EnhanceExposedFilters(view);
  }

  // Accordion Anchor Links
  AccordionAnchors();

  // TOC-WRAPPER image
  const tocWrapper = document.querySelector('#toc-wrapper');
  const nodeImage = document.querySelector('.node-image img');
  if (tocWrapper && nodeImage) {
    const tocHeight = tocWrapper.offsetHeight;
    nodeImage.setAttribute('style', `height: ${tocHeight}px !important; object-fit: cover; object-position: left;`);
    nodeImage.parentNode.parentNode.setAttribute('style', 'margin: 20px 0 0 0;');
  }
});
